<panel [header]="false">

  <div class="flex col">

    <div *ngIf="!selected.partner" class="bold uppercase">{{'Các đơn đặt hàng cần xử lý' | lang}}</div>
    <div *ngIf="selected.partner" class="flex space-between">
      <div *ngIf="!selected.order" class="bold uppercase">{{'Các đơn đặt hàng cần xử lý' | lang}} {{'cho' | lang}} {{selected.partner.Name}}</div>
      <div *ngIf="selected.order && selected.order.ID < 1" class="bold uppercase">{{'Tạo đơn đặt hàng mới' | lang}} {{'cho' | lang}} {{selected.partner.Name}}</div>
      <div *ngIf="selected.order && selected.order.ID > 0" class="bold uppercase">{{'Đơn đặt hàng cần xử lý' | lang}} {{'cho' | lang}} {{selected.partner.Name}}</div>
      <small *ngIf="selected.order && selected.order.ID > 0" class="button uppercase" (click)="close()">{{'Đóng đơn' | lang}}</small>
    </div>

    <div class="flex row">

      <div class="scrollable" #scrollableLeft>

        <table responsive class="data hover" *ngIf="!selected.order">
          <tr>
            <th class="text-center"><sortable [target]="orders" [extractor]="extractor('ID')" [selected]="true">{{'Mã đơn' | lang}}</sortable></th>
            <th class="text-center nowrap"><sortable [target]="orders" [extractor]="extractor('Stamp')">{{'Ngày' | lang}}</sortable></th>
            <th class="text-center"><sortable [target]="orders" [extractor]="extractor('State')">{{'Trạng thái' | lang}}</sortable></th>
            <th class="text-center nowrap"><sortable [target]="orders" [extractor]="extractor('Partner')">{{'Khách hàng' | lang}}</sortable></th>
            <th class="text-center"><sortable [target]="orders" [extractor]="extractor('Count')">{{'Mặt hàng' | lang}}</sortable></th>
            <th class="text-center"><sortable [target]="orders" [extractor]="extractor('Quantity')">{{'Số lượng' | lang}}</sortable></th>
            <th class="text-center"><sortable [target]="orders" [extractor]="extractor('Completion')">{{'Hoàn thành' | lang}}</sortable></th>
            <th class="text-center nowrap"><sortable [target]="orders" [extractor]="extractor('Creator')">{{'Người tạo' | lang}}</sortable></th>
          </tr>
          <tr *ngFor="let i of orders.pageMatches" class="pointer" (click)="open(i)">
            <td class="spacy" [ngClass]="{'small uppercase text-danger nowrap': i.Tag == null}">{{i.Tag ? i.Tag : ('chưa có' | lang)}}</td>
            <td>{{i.Stamp | date : 'dd-MM-yyyy'}}</td>
            <td class="uppercase small nowrap" [ngClass]="{'text-warning': i.State == 1, 'text-success': i.State == 2}">{{state(i)}}</td>
            <td class="uppercase">{{partner(i).Name}}</td>
            <td>{{count(i) | number : '1.0-0' : 'en-US'}}</td>
            <td>{{quantity(i) | number : '1.0-0' : 'en-US'}}</td>
            <td [ngClass]="{'text-danger': !i.Completed, 'text-success': i.Completed}">{{completion(i) * 100 | number : '1.0-0' : 'en-US'}}%</td>
            <td><small class="uppercase text-info bold">{{user(i.CreatorID).Username}}</small></td>
          </tr>
          <tr class="footer" *ngIf="orders.pages.length > 1">
            <td [colSpan]="8" class="text-center"><pagination [target]="orders"></pagination></td>
          </tr>
        </table>

        <table responsive class="data hover" *ngIf="selected.order">
          <tr>
            <th class="text-left">{{'Mã hàng' | lang}}</th>
            <th class="text-center">{{'Màu' | lang}}</th>
            <th class="text-center">{{'Số cây' | lang}}</th>
            <th class="text-right">{{'Trung bình' | lang}}</th>
            <th class="text-right">{{'Tổng dài / nặng' | lang}}</th>
            <th class="text-center">{{editable ? 'Giao sau' : 'Hẹn giao' | lang}}</th>
            <th class="text-right" *ngIf="!editable">{{'Đã giao' | lang}}</th>
            <th class="text-right" *ngIf="isAdmin">{{'Giá nhập' | lang}}</th>
            <th class="text-right" *ngIf="editable">{{'Triết khấu' | lang}}</th>
            <th class="text-right">{{'Giá bán' | lang}}</th>            
            <th class="text-right" *ngIf="editable"></th>
          </tr>
          <tr *ngFor="let i of selected.order.Details">
            <td>
              <good  class="bold spacy nowrap text-primary" [sku]="i.SKU"></good>
            </td>
            <td>
              <span class="text-warning bold">{{i.Color}}</span>
            </td>
            <td class="text-info bold">
              <number-input [fit]="true" *ngIf="editable" [allowNegative]="false" [min]="1" [decimalPlaces]="0" [value]="i.Quantity" (change)="set(i, $event.target, 'Quantity', true)"></number-input>
              <number *ngIf="!editable" [value]="i.Quantity" [good]="'none'" [sign]="false"></number>
            </td>
            <td class="nowrap">
              <ng-container *ngIf="average(i) > 0">
                <number [good]="'none'" [sign]="false" [value]="average(i)" [decimalPlaces]="1"></number>
                <unit>{{(i.Unit == 1 ? 'm' : 'kg') | lang}}/{{'cây' | lang}}</unit>
              </ng-container>
              <small class="text-warning uppercase" *ngIf="average(i) == 0">{{'không có' | lang}}</small>
            </td>
            <td>
              <ng-container *ngIf="editable">
                <number-input class="text-info bold" [fit]="true" [allowNegative]="false" [min]="0" [decimalPlaces]="0" [value]="i.ExpectedUnitQuantity" (change)="set(i, $event.target, 'ExpectedUnitQuantity', false)"></number-input>
                <product-unit [type]="i.Unit"></product-unit>
              </ng-container>
              <ng-container *ngIf="!editable && i.ExpectedUnitQuantity > 0">
                <number class="text-info bold" [value]="i.ExpectedUnitQuantity" [good]="'none'" [sign]="false"></number>
                <product-unit [type]="i.Unit"></product-unit>
              </ng-container>
              <span *ngIf="!editable && i.ExpectedUnitQuantity == 0" class="small uppercase">
                {{'Không có yêu cầu' | lang}}
              </span>
            </td>
            <td>
              <ng-container *ngIf="editable">
                <number-input class="text-info bold" [fit]="true" *ngIf="editable" [allowNegative]="false" [min]="0" [decimalPlaces]="0" [value]="i.ExpectedDelay" (change)="set(i, $event.target, 'ExpectedDelay', false)"></number-input>
                <unit>{{'ngày' | lang}}</unit>
              </ng-container>
              <ng-contaier *ngIf="!editable && i.ExpectedDelay > 0">
                {{deadline(i) | date : 'dd-MM-yyy'}}
              </ng-contaier>
              
              <span *ngIf="!editable && i.ExpectedUnitQuantity == 0" class="small uppercase">
                {{'Không có yêu cầu' | lang}}
              </span>
            </td>

            <td *ngIf="!editable" [ngClass]="{'text-success': i.Quantity <= i.Provided, 'text-danger': i.Provided == 0}">{{i.Provided | number : '1.0-2' : 'en-US'}}<unit>{{'cây' | lang}}</unit></td>
            <td *ngIf="isAdmin">
              <b [ngClass]="{'text-danger nowrap small uppercase': i.ImportUnitPrice <= 0}">{{i.ImportUnitPrice > 0 ? (i.ImportUnitPrice | number : '1.0-2' : 'en-US') : ('chưa có' | lang)}}</b>
              <cny-per-unit *ngIf="i.ImportUnitPrice > 0" [type]="i.Unit"></cny-per-unit>
            </td>
            <td class="nowrap" *ngIf="editable">
              <number-input class="bold" [ngClass]="{'text-info': adjustment(i) == 0, 'text-danger': adjustment(i) < 0}" [fit]="true" [disabled]="!isOwner || !i.Verified" [min]="0" [decimalPlaces]="4" [value]="-adjustment(i)" (change)="setAdjustment(i,$event.target)"></number-input>
              <cny-per-unit [type]="i.Unit"></cny-per-unit>
            </td>            
            <td class="nowrap">
              <b *ngIf="!isOwner || !i.Verified || !editable" [ngClass]="{'text-success' : i.QuoteUnitPrice > 0 && i.Verified, 'text-warning': i.QuoteUnitPrice > 0 && !i.Verified, 'text-danger nowrap small uppercase': i.QuoteUnitPrice <= 0}">{{i.QuoteUnitPrice > 0 ? (i.QuoteUnitPrice | number : '1.0-2' : 'en-US') : ('chưa có' | lang)}}</b>
              <number-input *ngIf="isOwner && i.Verified && editable" class="bold" [ngClass]="{'text-success' : i.QuoteUnitPrice > 0, 'text-danger': i.QuoteUnitPrice <= 0}" [fit]="true" [disabled]="!isOwner || !i.Verified" [min]="0" [decimalPlaces]="0" [value]="i.QuoteUnitPrice" (change)="setPrice(i,$event.target)"></number-input>
              <span *ngIf="i.QuoteUnitPrice > 0" class="opacity-75 hlf-margin-left">đ/m</span>
            </td>
            <td *ngIf="editable"><i class="fa fa-times pointer text-danger" (click)="remove(i)"></i></td>
          </tr>
        </table>

      </div>
      <scrollbar [target]="scrollableLeft"></scrollbar>

    </div>

    <div class="flex std-margin-top" *ngIf="selected.partner">
      <button *ngIf="!selected.order" class="bg-primary text-white" (click)="create()"><span>{{'Tạo đơn đặt hàng' | lang}} {{'cho' | lang}} {{selected.partner.Name}}</span></button>
      <button *ngIf="savable" class="bg-primary text-white" (click)="save()"><span>{{selected.order.ID > 0 ? 'Cập nhập đơn hàng' : 'Tạo đơn hàng' | lang}}</span></button>
      <button *ngIf="confirmable" class="bg-success text-white" (click)="confirm()"><span>{{'Xác nhận đơn đặt hàng' | lang}}</span></button>
      <button *ngIf="cancelable" class="bg-danger text-white" (click)="cancel()"><span>{{'Hủy đơn đặt hàng' | lang}}</span></button>
      <button *ngIf="unconfirmable" class="bg-warning text-white" (click)="unconfirm()"><span>{{'Mở lại đơn đặt hàng' | lang}}</span></button>
    </div>
  </div>
</panel>

<panel [header]="false" *ngIf="!selected.order || editable">

  <div class="flex col">

    <text-filter [target]="partners" *ngIf="!selected.order" [placeholder]="'Tìm tên khách hàng'"></text-filter>
    <text-filter [target]="products" *ngIf="selected.order" [placeholder]="'Tìm mã sản phẩm'"></text-filter>
    <div class="flex row">
      <div class="scrollable" #scrollableRight>

        <ng-container *ngIf="!selected.order">

          <div *ngFor="let i of partners.matches" (click)="toggle(i)" [ngClass]="{'active': i == selected.partner}">
            <icon-text [icon]="'fa fa-user'">
              <b>{{i.Name}}</b>
              <br />
              <span>{{i.Address}}</span>
            </icon-text>
          </div>
        </ng-container>

        <table class="data hover" *ngIf="selected.order">
          <tr>
            <th class="text-left">Mã hàng</th>
            <th class="text-center">Màu</th>
            <th class="text-center">Tồn kho</th>
            <th class="text-right">Giá bán</th>
          </tr>
          <ng-container *ngFor="let i of products.pageMatches">
            <tr *ngFor="let color of i.Colors" class="pointer" (click)="add(i, color.Color)">
              <td class="text-left"><good class="bold spacy nowrap" [sku]="i.SKU"></good></td>
              <td class="text-center bold text-info">{{color.Color}}</td>
              <td class="text-center bold text-primary">{{color.Available}}</td>
              <td class="text-right">
                <span *ngIf="i.UnitPrice > 0"><b class="text-success">{{price(i) | number : '1.0-2' : 'en-US'}}</b><cny-per-m></cny-per-m></span>
                <small class="text-danger" *ngIf="i.UnitPrice <= 0">chưa có giá</small>
              </td>
            </tr>
          </ng-container>
          <tr class="footer" *ngIf="products.pages.length > 1">
            <td [colSpan]="4" class="text-center"><pagination [target]="products"></pagination></td>
          </tr>
        </table>

      </div>
      <scrollbar [target]="scrollableRight"></scrollbar>
    </div>

  </div>
</panel>

<ngx-loading [show]="loading"></ngx-loading>
